import type { OrderDto, Statistic } from "@interfaces/stats";

export const mapToStatsState = (orderDto: OrderDto[]): Statistic[] => {
  if (!orderDto || !orderDto.length) return [];

  const setValue = <T, D>(value: T, defaultValue?: D) => {
    if (defaultValue) return defaultValue;

    return value;
  };

  return orderDto.map((order) => {
    return {
      id: setValue(order.id),
      num: setValue(order.num),
      statusName: setValue(order.statusName, ""),
      orderNumber: setValue(Number(order.clientNumber)),
      proNumber: setValue(order.proNumber, ""),
      puDate: setValue(order.puDate, ""),
      puCityName: setValue(order.puCityName, ""),
      delCityName: setValue(order.delCityName, ""),
      delDate: setValue(order.delDate, ""),
      podDate: setValue(order.podDate, ""),
      commodityName: setValue(order.commodityName, ""),
      weight: setValue(order.weight),
      pallets: setValue(order.pallets),
      onTime: setValue(order.onTime),
    };
  });
};
